import React, { useState } from 'react';
import classNames from 'classnames';

import css from './SectionGallery.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const [showModal, setShowModal] = useState(false);

  // Extract images
  const images = listing && listing.images ? listing.images : [];

  if (images.length === 0) {
    return null;
  }

  // Get URL for a given variant
  const getImageUrl = (image, variantName) => {
    if (image && image.id && image.attributes && image.attributes.variants && image.attributes.variants[variantName]) {
      return image.attributes.variants[variantName].url;
    }
    return null;
  };

  const mainVariant = 'scaled-xlarge';

  const imagesCount = images.length;
  const displayImages = images.slice(0, 5).map(img => ({
    id: img.id.uuid,
    src: getImageUrl(img, mainVariant) || getImageUrl(img, 'scaled-large') || getImageUrl(img, 'scaled-medium'),
    alt: listing?.attributes?.title || 'Listing gallery image'
  }));

  const count = Math.min(imagesCount, 5);
  const layoutConfigs = {
    1: { main: css.singleImage, subs: [] },
    2: { main: css.twoImagesLeft, subs: [css.twoImagesRight] },
    3: { main: css.threeImagesMain, subs: [css.threeImagesSub1, css.threeImagesSub2] },
    4: { main: css.fourImagesMain, subs: [css.fourImagesSub1, css.fourImagesSub2, css.fourImagesSub3] },
    5: { main: css.fiveImagesMain, subs: [css.fiveImagesSub1, css.fiveImagesSub2, css.fiveImagesSub3, css.fiveImagesSub4] }
  };

  const currentLayout = layoutConfigs[count] || layoutConfigs[5];
  const remainingCount = imagesCount - 5;

  return (
    <section className={css.galleryContainer}>
      <div className={css.galleryGrid} onClick={() => setShowModal(true)}>
        {displayImages.length > 0 && (
          <div className={classNames(css.mainImageWrapper, currentLayout.main)}>
            <img
              src={displayImages[0].src}
              alt={displayImages[0].alt}
              className={css.image}
            />
            <div className={css.imageOverlay} />
          </div>
        )}

        {displayImages.slice(1, 5).map((img, index) => {
          const subClass = currentLayout.subs[index];
          const isLastVisible = index === 3 && remainingCount > 0;

          return (
            <div key={`${img.id}-${index}`} className={classNames(css.subImageWrapper, subClass)}>
              <img
                src={img.src}
                alt={img.alt}
                className={css.image}
              />
              <div className={classNames(css.imageOverlay, css.subImageOverlay)} />

              {isLastVisible && (
                <div className={css.remainingOverlay}>
                  <span className={css.remainingCount}>+{remainingCount}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <button
        className={css.showAllBtn}
        onClick={() => setShowModal(!showModal)}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
        Show all photos
      </button>

      {/* TODO: Add a fullscreen modal or use Sharetribe's standard modal rendering here */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'black', display: 'flex', flexDirection: 'column' }}>
          <button onClick={() => setShowModal(false)} style={{ position: 'absolute', top: 24, left: 24, background: 'transparent', border: 'none', color: 'white', cursor: 'pointer' }}>Close</button>
          <div style={{ flex: 1, overflowY: 'auto', padding: '80px 24px', display: 'flex', flexDirection: 'column', gap: 24, alignItems: 'center' }}>
            {images.map(img => (
              <img key={img.id.uuid} src={getImageUrl(img, 'scaled-xlarge')} style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default SectionGallery;
